// extracted by mini-css-extract-plugin
export default {"fieldset":"fieldset_fieldset__HpFUt","fieldset--inline":"fieldset_fieldset--inline__8E1O4","label":"fieldset_label__1+NCy","input":"fieldset_input__TRl3J"};